angular.module('qkr.payment.gateway')
    .controller('paymentGatewayController', paymentGatewayController);

paymentGatewayController.$inject = ['$scope', '$rootScope', '$routeSegment', 'merchantService',
    'paymentgatewayService', 'departmentService', 'FormHelper',
    'messageService', '$uibModal', 'appConfig', 'gettextCatalog'];

function paymentGatewayController($scope, $rootScope, $routeSegment, merchantService,
                                  paymentgatewayService, departmentService, FormHelper,
                                  messageService, $uibModal, appConfig, gettextCatalog) {
    $scope.$routeSegment = $routeSegment; // Used to know what we've selected
    $scope.saving = false;
    $scope.loaded = false;
    $scope.paymentSettings = [];
    $scope.currencies = [];
    $scope.form = {};
    $scope.outletLevel = appConfig.outletLevel;
    $scope.isElevatedUser = paymentgatewayService.isPaymentSettingsUpdateAllowed();

    const init = function() {
        // Load payment systems types first...
        paymentgatewayService.getPaymentSystems();
        const responder = function(response) {
            injectPaymentSettings(response);
        };

        paymentgatewayService.loadPaymentSettingsList().then(responder, responder);
    };

    const formHelper = new FormHelper($scope);

    var injectPaymentSettings = function(response) {
        const r = formHelper.handleResponse(response);

        if (r.isSuccess()) {
            if ($scope.outletLevel) {
                departmentService.loadDepartments().then((promise) => {
                    $scope.allDeparments = promise;
                    const collection = [];

                    for (let i = response.data.length - 1; i > -1; i--) {
                        const paymentSetting = response.data[i];
                        paymentSetting.departments = paymentgatewayService.getDepartments(paymentSetting, promise);
                        collection.push(paymentSetting);
                    }

                    $scope.paymentSettings = collection.sort(
                        (paymentSettingA, paymentSettingB) => {
                            if(paymentSettingA.outlet){
                                return -1;
                            }
                            else if (paymentSettingB.outlet){
                                return 1;
                            }
                            return 0;
                        });


                    $scope.loaded = true;
                });
            } else {
                $scope.paymentSettings = filterPaymentsForMerchantLevel(response.data);
                $scope.loaded = true;
            }
        } else {
            messageService.error(gettextCatalog.getString('An error occurred while loading payment settings. Please try again'));
            $scope.errors = formHelper.parseFieldErrors(response);
        }
    };

    $scope.create = function() {
        const modalInstance = $uibModal.open({
            template: require('../../payment-gateway/templates/paymentgateway.html'),
            controller: 'paymentGatewayModalController',
            windowClass: 'fade modal-huge',
            backdrop: 'static',
            resolve: {
                newPaymentSetting() {
                    return true;
                },
                paymentSetting() {
                    return {};
                },
                existingDefault() {
                    return paymentgatewayService.hasExistingDefault($rootScope);
                },
                paymentSystems() {
                    return paymentgatewayService.getPaymentSystems();
                },
                bankAccountTypes() {
                    return paymentgatewayService.getBankAccountTypes()
                }
            }
        });
    };

    $scope.update = function(paymentSetting) {
        const modalInstance = $uibModal.open({
            template: require('../../payment-gateway/templates/paymentgateway.html'),
            controller: 'paymentGatewayModalController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                newPaymentSetting() {
                    return false;
                },
                paymentSetting() {
                    return paymentSetting;
                },
                existingDefault() {
                    return paymentgatewayService.hasExistingDefault($rootScope);
                },
                paymentSystems() {
                    return paymentgatewayService.getPaymentSystems();
                },
                bankAccountTypes() {
                    return paymentgatewayService.getBankAccountTypes()
                }
            }
        });
    };

    $scope.markAsFallback = function(paymentSetting) {
        const responder = function(response) {
            const r = formHelper.handleResponse(response);

            if (r.isSuccess()) {
                $rootScope.$broadcast('merchantInfoChanged');
                $rootScope.$broadcast('paymentSettingsChanged', response);
            } else {
                messageService.error(gettextCatalog.getString('An error occurred while marking as default. Please try again'));
                $scope.errors = formHelper.parseFieldErrors(response);
            }
        };

        paymentgatewayService.markAsFallback(paymentSetting.id).then(responder, responder);
    };

    $scope.markAsActive = function(paymentSetting) {
        const responder = function(response) {
            const r = formHelper.handleResponse(response);

            if (r.isSuccess()) {
                $rootScope.$broadcast('merchantInfoChanged');
                init();
            } else {
                messageService.error(gettextCatalog.getString('An error occurred while setting active. Please try again'));
                $scope.errors = formHelper.parseFieldErrors(response);
            }
        };

        const updateDepartment = $scope.allDeparments[0];
        updateDepartment.paymentConfig = paymentSetting;

        departmentService.updateDepartmentPost(updateDepartment).then(responder, responder);
    };

    $scope.delete = function(id) {
        const responder = function(response) {
            const r = formHelper.handleResponse(response);

            if (r.isSuccess()) {
                let index = -1;
                for (let i = $scope.paymentSettings.length - 1; i > -1; i--) {
                    const item = $scope.paymentSettings[i];
                    if (item.id == id) {
                        index = i;
                        break;
                    }
                }

                const responder = function(promise) {
                    $rootScope.$broadcast('paymentSettingsChanged', promise);
                };

                if (index > -1) {
                    $scope.paymentSettings.splice(index, 1);
                    paymentgatewayService.loadPaymentSettingsList().then(responder, responder);
                }
            } else {
                console.log(r.response.data.message);
                messageService.error(r.response.data.message);
                $scope.errors = formHelper.parseFieldErrors(response);
            }
        };

        paymentgatewayService.delete(id).then(responder, responder);
    };

    $scope.allowAction = function(actionName, paymentSetting) {
        switch (actionName) {
            case 'markDefault': {
                let allowedSetDefaultAtOutletLevel = merchantService.behaviour(merchantService.merchantInfo,
                    'paymentPage.allowedSetDefaultAtOutletLevel');
                return !paymentSetting.fallback && (!$scope.outletLevel || allowedSetDefaultAtOutletLevel);
            }
            case 'markActive': {
                let allowedMarkActive = merchantService.behaviour(merchantService.merchantInfo,
                    'paymentPage.allowedMarkActive');
                return $scope.outletLevel && allowedMarkActive && (paymentSetting.departments.length <= 0);
            }
            case 'edit': {
                let allowed = true;
                if ($scope.outletLevel && !paymentSetting.outlet) {
                    allowed = false;
                }
                allowed = paymentgatewayService.isPaymentSettingsUpdateAllowed(); // this check needs to take precedence
                return allowed;
            }
            case 'delete': {
                let noDepts = true;
                if (paymentSetting.departments && paymentSetting.departments.length > 0) {
                    noDepts = false;
                }
                return !paymentSetting.fallback && noDepts && (appConfig.isMCAdmin || appConfig.isPartner);
            }
        }
    };

    $scope.showDepartmentsCol = function() {
        return ($scope.outletLevel && merchantService.behaviour(merchantService.merchantInfo, 'paymentPage.showDepartmentsCol'));
    };

    $scope.showActiveCol = function() {
        return ($scope.outletLevel && merchantService.behaviour(merchantService.merchantInfo, 'paymentPage.showActiveCol'));
    };

    $scope.showDefaultForMerchantCol = function() {
        return (!$scope.outletLevel || merchantService.behaviour(merchantService.merchantInfo, 'paymentPage.showDefaultForMerchantCol'));
    };

    $scope.$on('paymentSettingsChanged', (evt, response) => {
        injectPaymentSettings(response);
    });

    function filterPaymentsForMerchantLevel(collection) {
        const result = collection.filter((item) =>
            // The payment item that has an outlet property means that was created at outlet level.
            !item.hasOwnProperty('outlet'));

        return result;
    }

    init();
}



// WEBPACK FOOTER //
// ./src/payment-gateway/controllers/paymentgateway.controller.js